<template>
    <!-- 预算科目列表 -->
    <vBudgetAccountListComponent :postList="postList" v-if="flag"></vBudgetAccountListComponent>
</template>
<script>
import vBudgetAccountListComponent from '../../listComponent/budget/budgetAccountList/budgetAccountListComponent.vue';
export default {
    name: 'budgetAccountList',
    components: {
        vBudgetAccountListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                remark: true,
                label: true,
                type: true,
                principal_rid: true,
                assistance: true,
                accounting_attribute: true,
                status: true,
                department_rid: true,
                budget_object_rid: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>